export const UNAUTHORIZED_STATUS_CODE = 401;
export const NOT_FOUND_STATUS_CODE = 404;
export const REQUEST_TIMEOUT_STATUS_CODE = 408;
export const TOO_MANY_REQUESTS_STATUS_CODE = 429;

export const INTERNAL_SERVER_ERROR_STATUS_CODE = 500;
export const BAD_GATEWAY_STATUS_CODE = 502;
export const SERVICE_UNAVAILABLE_STATUS_CODE = 503;
export const GATEWAY_TIMEOUT_STATUS_CODE = 504;
